import axios from 'axios'
import { AUTH_HEADERS } from '../utils/config'

export default {
  getLabels () {
    return axios.get(`${process.env.VUE_APP_BASE_URL}planningChecklist/labels`, AUTH_HEADERS())
  },
  get (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}planningChecklist/${id}`, AUTH_HEADERS())
  },
  getByTask (id) {
    return axios.get(`${process.env.VUE_APP_BASE_URL}planningChecklist/workOrderTask/${id}/checklist`, AUTH_HEADERS())
  },
  update (id, checklist) {
    return axios.put(`${process.env.VUE_APP_BASE_URL}planningChecklist/update/${id}`, checklist, AUTH_HEADERS())
  },
  add (checklist) {
    return axios.post(`${process.env.VUE_APP_BASE_URL}planningChecklist`, checklist, AUTH_HEADERS())
  },
  delete (id) {
    return axios.delete(`${process.env.VUE_APP_BASE_URL}planningChecklist/delete/${id}`, AUTH_HEADERS())
  }

}
